import styled from 'styled-components';
import { LinkText } from '@origin-digital/style-guide';

export const UndecoratedLink = styled(LinkText)`
  text-decoration: none;
  font-weight: 400;
`;
